import type * as ents from '@attain-apps/entities'

import type * as models from './models'

export interface State {
  /** Represents users available for assignment */
  users: readonly models.User[]
  selectedUserIds: readonly ents.core.admin.User.Id[]
  isEditing: boolean
  access: ents.core.admin.Access
  markedUserForUnassignment?: models.User
  error?: Error
  mutationError?: Error
  excludePages?: Set<string>
  includePages?: Set<string>
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    access: 0,
    error: undefined,
    excludePages: undefined,
    includePages: undefined,
    isEditing: false,
    markedUserForUnassignment: undefined,
    mutationError: undefined,
    selectedUserIds: [],
    users: [],
  }

  /**
   * Reset state to initial values
   */
  export function setInitial(): State {
    return INITIAL
  }

  /**
   * Reset editing state to initial values
   */
  export function reset(state: State): State {
    return {
      ...state,
      access: 0,
      excludePages: undefined,
      includePages: undefined,
      isEditing: false,
      markedUserForUnassignment: undefined,
      mutationError: undefined,
      selectedUserIds: [],
    }
  }
}
